import { Extension } from '@tiptap/core';

export enum AlertTransactions {
  WARNING = 'warning',
}

export type AlertEvents = {
  warning: {
    message: string;
    coords: {
      left: number;
      right: number;
      top: number;
      bottom: number;
    };
  };
};

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    alert: {
      showWarning: (message: string) => ReturnType;
    };
  }
}

const Alert = Extension.create({
  name: 'alert',
  addCommands() {
    return {
      showWarning:
        (message: string) =>
        ({ editor, tr }) => {
          const { from } = editor.state.selection;
          // Calculate the cursor position
          const coords = editor.view.coordsAtPos(from);
          tr.setMeta(AlertTransactions.WARNING, { message, coords });
          return true;
        },
    };
  },
});

export default Alert;
